// Imports ------------------------------------------------------------------->

// Private Definitions ------------------------------------------------------->

import { COLOR_BRAND3 } from '../services/ConfigService'

class SpinnerIcons {
    get apple() {
        return (
            <svg viewBox="0 0 100 100">
                <path
                    fill="#419251"
                    d="M56.62,31.23s1-25.15-29.69-24.93C26.93,6.3,25.21,35.82,56.62,31.23Z"
                />
                <path
                    fill="#61be7a"
                    d="M56.49,28.8s1-21.9-23.86-21.72C32.62,7.09,31,32.54,56.49,28.8Z"
                />
                <path
                    fill="#e45263"
                    d="M85.71,43.21c-8.68-12-30-9.26-30-9.26l-.12.2-.05-.23s-19.39-8.75-31.4-.07S16.94,71.78,19.7,76.58c0,0,9.14,21.58,26.7,14.6,14.47,12.15,29.94-5.47,29.94-5.47C80.47,82,94.39,55.22,85.71,43.21Z"
                />
                <path
                    fill="#fff"
                    d="M56.57,36.74l0,.23.11-.2s19-3.24,26.5,8.78c5.2,8.36.52,24.2-4.07,34.37,5-8.37,13.37-29.19,6.84-39.21-7.7-11.81-27.07-8.77-27.07-8.77l-.11.2,0-.22s-3.18,2.23-3.47,4.21c-.12.83,1.46-1.76.91-1.11C67.46,29.7,56.57,36.74,56.57,36.74Z"
                />
                <ellipse
                    fill="#d62b47"
                    cx="55.63"
                    cy="38.67"
                    rx="2.25"
                    ry="6.69"
                    transform="translate(8.59 87.43) rotate(-80.84)"
                />
                <path
                    fill="#594942"
                    d="M44.67,32a22.51,22.51,0,0,1-11.91-5.53c-8.7-8-8.06-20.91-8-21.46l.1-1.75h1.75C37.21,3.18,45.4,6,50.93,11.74a27,27,0,0,1,7.23,18.39l-.06,1.55-1.54.23A39.23,39.23,0,0,1,44.67,32ZM28.48,7c.16,3.54,1.17,11.55,6.82,16.72,4.4,4,10.81,5.59,19,4.68a23.29,23.29,0,0,0-6.15-14.11C43.73,9.72,37.1,7.27,28.48,7Z"
                />
                <rect
                    fill="#594942"
                    x="43.76"
                    y="8.52"
                    width="3.74"
                    height="27.79"
                    transform="translate(-1.41 41.7) rotate(-48.45)"
                />
                <circle
                    fill="#594942"
                    cx="35.5"
                    cy="13.41"
                    r="1.89"
                    transform="translate(16.61 46.33) rotate(-80.84)"
                />
                <path
                    fill="#594942"
                    d="M56.54,38.13S47.06,19.9,58.62,9.34c0,0,4.65-2.25,6.69,3.65,0,0-10.64,12.85-5.84,25.62Z"
                />
                <ellipse
                    fill="#594942"
                    cx="55.71"
                    cy="38.18"
                    rx="1.97"
                    ry="6.69"
                    transform="translate(9.15 87.1) rotate(-80.84)"
                />
                <path
                    fill="#d62b47"
                    d="M49.56,84.78C32.75,91.53,26.12,71,26.12,71c-2.63-4.61-7.17-32.62,4.19-41.1a19.2,19.2,0,0,0-6,2.86c-12,8.68-7.21,37.94-4.44,42.74,0,0,9.14,21.58,26.7,14.6,14.47,12.15,29.94-5.47,29.94-5.47a20.32,20.32,0,0,0,3.05-4.11C76.43,83.67,61.58,94.94,49.56,84.78Z"
                />
                <path
                    fill="#594942"
                    d="M36.69,93.67c-9.5-1.53-16-10.37-18.66-16.25-3-5.4-8.07-36.13,5.11-45.65C35.06,23.16,53,30.22,56,31.48c3.25-.34,22.69-1.86,31.31,10.07h0c9.5,13.15-5,40.68-9.55,44.92-5.68,6.42-19.33,15.65-31.62,6.28A19.25,19.25,0,0,1,36.69,93.67Zm6.88-61.84c-5.88-.95-12.92-.87-18.23,3-10.9,7.87-6.4,36.69-4,40.85l.09.18c.35.79,8.74,19.28,24.39,13.06l1-.41.86.72C60.58,100,74.44,84.58,75,83.92l.16-.16c3.59-3.2,17-29.14,9.1-40-7-9.66-23.42-8.91-27.37-8.58l-2,3.21L54,34.72A52.06,52.06,0,0,0,43.57,31.83Z"
                />
                <g opacity="0.5">
                    <rect
                        fill="#fff"
                        x="29.05"
                        y="39.32"
                        width="4.73"
                        height="3.74"
                        transform="translate(-14.25 65.65) rotate(-80.84)"
                    />
                    <circle
                        fill="#fff"
                        cx="31.74"
                        cy="39.22"
                        r="1.89"
                        transform="translate(-14.91 19.99) rotate(-28.61)"
                    />
                    <circle
                        fill="#fff"
                        cx="31.04"
                        cy="43.53"
                        r="1.89"
                        transform="translate(-17.05 20.18) rotate(-28.61)"
                    />
                </g>
                <g opacity="0.5">
                    <rect
                        fill="#fff"
                        x="22.99"
                        y="54.44"
                        width="11.99"
                        height="3.74"
                        transform="translate(-31.23 75.96) rotate(-80.84)"
                    />
                    <circle
                        fill="#fff"
                        cx="29.93"
                        cy="50.4"
                        r="1.89"
                        transform="translate(-20.48 20.49) rotate(-28.61)"
                    />
                    <circle
                        fill="#fff"
                        cx="28.03"
                        cy="62.23"
                        r="1.89"
                        transform="translate(-26.38 21.02) rotate(-28.61)"
                    />
                </g>
                <path
                    fill="#594942"
                    d="M46,51.72l-.06.42c0,.07-1,7.26,5.57,8.24s7.72-6.18,7.74-6.25l.06-.42Z"
                />
                <path
                    fill="#f0bbd6"
                    d="M52.25,55.36c-2.1-.31-4,.35-4.7,1.52.33,1.33,1.95,2.52,4,2.83s4-.35,4.7-1.52C56,56.86,54.35,55.67,52.25,55.36Z"
                />
                <circle
                    fill="#594942"
                    cx="61.55"
                    cy="50.71"
                    r="2.68"
                    transform="matrix(0.16, -0.99, 0.99, 0.16, 1.69, 103.4)"
                />
                <circle
                    fill="#594942"
                    cx="44.91"
                    cy="48.03"
                    r="2.68"
                    transform="translate(-9.65 84.72) rotate(-80.84)"
                />
            </svg>
        )
    }

    get cheese() {
        return (
            <svg viewBox="0 0 100 100">
                <path
                    fill="#f3e57b"
                    d="M82.57,47.78a8.85,8.85,0,0,1,6.65-10.61L86.11,23.59,4,42.4,14.15,86.82,96.28,68,93.18,54.43A8.85,8.85,0,0,1,82.57,47.78Z"
                />
                <polygon
                    fill="#fdbe28"
                    points="6.4 41.85 35.52 16.64 83.25 23.25 6.4 41.85"
                />
                <rect
                    fill="#fff"
                    x="8.88"
                    y="41.37"
                    width="4.36"
                    height="45.57"
                    transform="translate(-14.04 4.09) rotate(-12.9)"
                />
                <rect
                    fill="#fff"
                    x="43.35"
                    y="-5.99"
                    width="4.36"
                    height="82.22"
                    transform="translate(69.6 -17.1) rotate(77.1)"
                />
                <path
                    fill="#5a4a43"
                    d="M98.51,69.52l-86,19.69L1.49,41l86-19.69,4,17.41-1.91.44a6.89,6.89,0,1,0,3.08,13.43l1.91-.44Zm-83,15L93.8,66.56l-2.27-9.92A10.82,10.82,0,0,1,86.78,35.9L84.51,26,6.2,43.91Z"
                />
                <polygon
                    fill="#5a4a43"
                    points="85.71 25.57 36.1 18.7 5.09 43.95 2.61 40.91 34.95 14.58 86.25 21.68 85.71 25.57"
                />
                <circle
                    fill="#fdbe28"
                    cx="17.38"
                    cy="53.76"
                    r="1.65"
                    transform="translate(-11.56 5.24) rotate(-12.9)"
                />
                <circle
                    fill="#fdbe28"
                    cx="25.18"
                    cy="55.02"
                    r="2.71"
                    transform="translate(-11.65 7.01) rotate(-12.9)"
                />
                <circle
                    fill="#fdbe28"
                    cx="31.67"
                    cy="47.69"
                    r="2.32"
                    transform="translate(-9.85 8.27) rotate(-12.9)"
                />
                <path
                    fill="#594942"
                    d="M44.17,55.66l.11.44c0,.08,1.91,7.56,8.79,5.9s5.15-9.18,5.13-9.26l-.11-.44Z"
                />
                <path
                    fill="#f0bbd6"
                    d="M51.76,56.76c-2.2.53-3.81,1.94-4,3.38.85,1.18,2.93,1.7,5.12,1.17s3.81-1.94,4-3.38C56,56.75,54,56.23,51.76,56.76Z"
                />
                <circle
                    fill="#594942"
                    cx="59.07"
                    cy="48.46"
                    r="2.86"
                    transform="translate(-9.33 14.41) rotate(-12.9)"
                />
                <circle
                    fill="#594942"
                    cx="41.58"
                    cy="52.46"
                    r="2.86"
                    transform="translate(-10.66 10.61) rotate(-12.9)"
                />
            </svg>
        )
    }

    get bread() {
        return (
            <svg viewBox="0 0 100 100">
                <g id="O4OaZ4.tif">
                    <path
                        fill="#a27a60"
                        d="M92.63,30.14V33.2a15,15,0,0,1-5.17,7.51,2.31,2.31,0,0,0-.57,1.58q-.38,14.29-.68,28.57c-.1,4.85-.17,9.7-.25,14.56H28.47c0-.5.08-1,.07-1.51-.29-13.23-.63-26.46-.86-39.69,0-1.93-.41-3.39-2.08-4.58a10.55,10.55,0,0,1-2.52-2.92,8.6,8.6,0,0,1-.35-9.32,15.67,15.67,0,0,1,5.34-5.53c5.46-3.64,11.6-5.38,18-6.41,2.09-.33,4.19-.57,6.29-.86h9.72a8,8,0,0,0,1.19.27A53.71,53.71,0,0,1,78.35,18C84.52,20.35,90.3,23.24,92.63,30.14Z"
                    />
                </g>
                <g id="O4OaZ4.tif-2" data-name="O4OaZ4.tif">
                    <path
                        fill="#5a4a43"
                        d="M86,87.48H28.47a2.07,2.07,0,0,1-2.07-2.17l0-.53c0-.28,0-.56,0-.84L26.22,73c-.22-9.44-.45-19.2-.61-28.8,0-1.63-.3-2.28-1.2-2.92a12.35,12.35,0,0,1-3.06-3.48,10.66,10.66,0,0,1-.44-11.43,17.66,17.66,0,0,1,6-6.28c5-3.33,11-5.47,18.82-6.73,1.45-.23,2.91-.42,4.37-.61l2-.26.28,0h9.72a2.06,2.06,0,0,1,.47.06l.45.12a3.56,3.56,0,0,0,.41.1,55.49,55.49,0,0,1,15.67,3.28c6.09,2.31,12.82,5.44,15.5,13.4a2.07,2.07,0,0,1,.11.66V33.2a2.08,2.08,0,0,1-.08.58A16.81,16.81,0,0,1,89,42.13a1.15,1.15,0,0,0,0,.21q-.38,14.28-.68,28.56c-.07,3.37-.13,6.75-.18,10.12L88,85.45A2.07,2.07,0,0,1,86,87.48ZM30.6,83.34H83.93L84,81c.05-3.38.11-6.77.18-10.15q.31-14.29.68-28.58a4.34,4.34,0,0,1,1.33-3.13,13,13,0,0,0,4.41-6.21v-2.4c-2-5.43-6.42-8.07-12.94-10.54a51.42,51.42,0,0,0-14.51-3,6.07,6.07,0,0,1-1.22-.24l-.08,0H52.49l-1.86.24c-1.42.18-2.83.36-4.24.59-7.23,1.16-12.69,3.09-17.18,6.09a13.49,13.49,0,0,0-4.67,4.79,6.57,6.57,0,0,0,.26,7.22,8.84,8.84,0,0,0,2,2.36,7.05,7.05,0,0,1,3,6.23c.17,9.59.39,19.35.61,28.78Z"
                    />
                </g>
                <g id="O4OaZ4.tif-3" data-name="O4OaZ4.tif">
                    <path
                        fill="#fff2c5"
                        d="M78.88,30.14V33.2a15,15,0,0,1-5.17,7.51,2.31,2.31,0,0,0-.57,1.58q-.38,14.29-.68,28.57c-.1,4.85-.17,9.7-.25,14.56H14.72c0-.5.08-1,.07-1.51-.29-13.23-.63-26.46-.86-39.69,0-1.93-.41-3.39-2.08-4.58a10.55,10.55,0,0,1-2.52-2.92A8.6,8.6,0,0,1,9,27.39a15.67,15.67,0,0,1,5.34-5.53c5.46-3.64,11.6-5.38,18-6.41,2.09-.33,4.19-.57,6.29-.86h9.72a8,8,0,0,0,1.19.27A53.71,53.71,0,0,1,64.6,18C70.77,20.35,76.55,23.24,78.88,30.14Z"
                    />
                </g>
                <path
                    fill="#f3e1a3"
                    d="M19.79,79.13c0-.5.08-1,.07-1.51-.29-13.23-.63-26.46-.86-39.69,0-1.93-.41-3.39-2.08-4.58a10.54,10.54,0,0,1-2.52-2.92,8.57,8.57,0,0,1-.46-9.09c-.27.17-.55.33-.83.51a15.66,15.66,0,0,0-5.34,5.53,8.6,8.6,0,0,0,.35,9.32,10.55,10.55,0,0,0,2.52,2.92c1.67,1.18,2,2.64,2.08,4.58.23,13.23.56,26.46.86,39.69,0,.5,0,1-.07,1.51H71q.05-3.14.11-6.28Z"
                />
                <path
                    fill="#fff"
                    d="M62.32,18a53.71,53.71,0,0,0-15.09-3.16A8,8,0,0,1,46,14.59H43.8a8,8,0,0,0,1.19.27A53.71,53.71,0,0,1,60.07,18c6.17,2.34,12,5.22,14.27,12.13V33.2c-.9,3.07-3.31,4.42-5.78,6.43A2.31,2.31,0,0,0,68,41.21c-.25,9.52.13,20.12-.07,29.65-.1,4.85-.17,9.7-.25,14.56h2.25c.08-4.85.14-9.7.25-14.56q.31-14.29.68-28.57a2.31,2.31,0,0,1,.57-1.58A15,15,0,0,0,76.6,33.2V30.14C74.27,23.24,68.49,20.35,62.32,18Z"
                />
                <path
                    fill="#b48c72"
                    d="M64.19,17.14A53.72,53.72,0,0,0,49.1,14a8,8,0,0,1-1.19-.27H38.19c-2.1.28-4.2.52-6.29.86-6.39,1-12.54,2.77-18,6.41a15.66,15.66,0,0,0-5.34,5.53,8.54,8.54,0,0,0-.49,7.72,11.29,11.29,0,0,1,.49-1.05,15.66,15.66,0,0,1,5.34-5.53c5.46-3.64,11.6-5.38,18-6.41,2.09-.33,4.19-.57,6.29-.86h9.72a8,8,0,0,0,1.19.27,53.72,53.72,0,0,1,15.09,3.16c5.62,2.13,10.89,4.75,13.54,10.42a14,14,0,0,0,.73-1.9V29.27C76.14,22.37,70.36,19.48,64.19,17.14Z"
                />
                <g id="O4OaZ4.tif-4" data-name="O4OaZ4.tif">
                    <path
                        fill="#5a4a43"
                        d="M71.81,87.48H14.31a2.07,2.07,0,0,1-2.07-2.17l0-.51c0-.28,0-.57,0-.85l-.25-11.1c-.22-9.37-.44-19.06-.61-28.6,0-1.63-.3-2.28-1.2-2.92a12.38,12.38,0,0,1-3.06-3.48,10.67,10.67,0,0,1-.44-11.43,17.68,17.68,0,0,1,6-6.28c5-3.33,11-5.47,18.82-6.73C33,13.17,34.5,13,36,12.79l2-.26.28,0h9.72a2.09,2.09,0,0,1,.47.05l.46.12a3.73,3.73,0,0,0,.41.1,55.47,55.47,0,0,1,15.67,3.28c6.1,2.31,12.82,5.44,15.5,13.4a2.07,2.07,0,0,1,.11.66V33.2a2,2,0,0,1-.08.58,16.8,16.8,0,0,1-5.63,8.35,1.15,1.15,0,0,0,0,.21q-.38,14.28-.68,28.56C74,74.27,74,77.63,73.94,81l-.07,4.44A2.07,2.07,0,0,1,71.81,87.48ZM16.44,83.34H69.77l0-2.4c.05-3.38.1-6.75.18-10.13q.31-14.29.68-28.58A4.34,4.34,0,0,1,72,39.1a13,13,0,0,0,4.41-6.21v-2.4c-2-5.43-6.42-8.07-12.94-10.54a51.39,51.39,0,0,0-14.51-3,6.07,6.07,0,0,1-1.21-.24l-.08,0H38.34l-1.85.24c-1.42.18-2.84.36-4.25.59C25,18.65,19.55,20.58,15.07,23.57a13.49,13.49,0,0,0-4.67,4.79,6.57,6.57,0,0,0,.26,7.22,8.88,8.88,0,0,0,2,2.36,7.05,7.05,0,0,1,3,6.23c.16,9.52.39,19.21.61,28.58Z"
                    />
                </g>
                <circle fill="#5a4a43" cx="19.72" cy="30.83" r="1.88" />
                <circle
                    fill="#5a4a43"
                    opacity="0.3"
                    cx="26.69"
                    cy="30.83"
                    r="1.88"
                />
                <circle fill="#5a4a43" cx="23.04" cy="37.11" r="1.88" />
                <path
                    fill="#594942"
                    d="M33.22,46l0,.47c0,.08-.19,8.12,6.62,8.34S47,47,47,46.87l0-.47Z"
                />
                <path
                    fill="#f0bbd6"
                    d="M40,49.15c-2.17-.07-4,.91-4.61,2.3.48,1.42,2.27,2.51,4.45,2.58s4-.91,4.61-2.3C43.93,50.31,42.14,49.22,40,49.15Z"
                />
                <ellipse
                    fill="#594942"
                    cx="49.36"
                    cy="41.82"
                    rx="2.84"
                    ry="3.08"
                    transform="translate(-1.73 2.13) rotate(-2.43)"
                />
                <ellipse
                    fill="#594942"
                    cx="30.48"
                    cy="41.94"
                    rx="2.84"
                    ry="3.08"
                    transform="translate(-1.75 1.33) rotate(-2.43)"
                />
            </svg>
        )
    }

    get basket() {
        return (
            <svg viewBox="0 0 100 100">
                <path
                    fill={COLOR_BRAND3}
                    d="M91.49,63.25a3.39,3.39,0,0,1-2.85-1.54l-20.79-32a3.31,3.31,0,0,1,.91-4.56,3.4,3.4,0,0,1,4.77.95l20.79,32a3.31,3.31,0,0,1-.91,4.56A3.36,3.36,0,0,1,91.49,63.25Z"
                />
                <path
                    fill="#5f5271"
                    d="M70.68,25.94a2,2,0,0,1,1.7.92l20.79,32a2,2,0,0,1-.54,2.69h0A2,2,0,0,1,89.78,61L69,29a2,2,0,0,1,.54-2.69,2,2,0,0,1,1.14-.35m0-2.74h0A4.74,4.74,0,0,0,68,24a4.68,4.68,0,0,0-1.28,6.44l20.79,32a4.77,4.77,0,0,0,6.69,1.33,4.68,4.68,0,0,0,1.28-6.44l-20.79-32a4.75,4.75,0,0,0-4-2.16Z"
                />
                <g opacity="0.5">
                    <ellipse
                        fill="#cadef9"
                        cx="50"
                        cy="77.44"
                        rx="42.5"
                        ry="5.74"
                    />
                </g>
                <path
                    fill={COLOR_BRAND3}
                    d="M9.09,63.25a3.38,3.38,0,0,1-1.92-.59,3.32,3.32,0,0,1-.91-4.56L27,26.12a3.4,3.4,0,0,1,4.77-.95,3.31,3.31,0,0,1,.91,4.56l-20.79,32a3.39,3.39,0,0,1-2.85,1.54Z"
                />
                <path
                    fill="#5f5271"
                    d="M29.9,25.94A2,2,0,0,1,31,26.3,2,2,0,0,1,31.58,29L10.79,61a2,2,0,0,1-2.85.56h0a2,2,0,0,1-.54-2.69l20.79-32a2,2,0,0,1,1.7-.92m0-2.74a4.75,4.75,0,0,0-4,2.16l-20.79,32a4.68,4.68,0,0,0,1.28,6.44,4.77,4.77,0,0,0,6.69-1.33l20.79-32A4.68,4.68,0,0,0,32.59,24a4.74,4.74,0,0,0-2.69-.84Z"
                />
                <path
                    fill="#fff"
                    d="M27,77A11.43,11.43,0,0,1,15.74,68.6L6.45,32.17H94.13L84.84,68.6A11.43,11.43,0,0,1,73.57,77Z"
                />
                <path
                    fill="#5f5271"
                    d="M92.37,33.54,83.52,68.27a10.1,10.1,0,0,1-9.94,7.32H27a10.1,10.1,0,0,1-9.94-7.32L8.21,33.54H92.37m3.52-2.74H4.69l.87,3.41,8.85,34.72A12.8,12.8,0,0,0,27,78.32H73.57a12.8,12.8,0,0,0,12.6-9.38L95,34.22l.87-3.41Z"
                />
                <rect
                    fill="#cadef9"
                    x="1.83"
                    y="24.57"
                    width="96.35"
                    height="14.62"
                    rx="2.87"
                    ry="2.87"
                />
                <path
                    fill="#5f5271"
                    d="M95.3,25.94a1.51,1.51,0,0,1,1.5,1.5v8.87a1.51,1.51,0,0,1-1.5,1.5H4.7a1.51,1.51,0,0,1-1.5-1.5V27.45a1.51,1.51,0,0,1,1.5-1.5H95.3m0-2.74H4.7A4.25,4.25,0,0,0,.46,27.45v8.87A4.25,4.25,0,0,0,4.7,40.56H95.3a4.25,4.25,0,0,0,4.24-4.24V27.45A4.25,4.25,0,0,0,95.3,23.2Z"
                />
                <rect
                    fill="#cadef9"
                    x="25.88"
                    y="46.34"
                    width="6.02"
                    height="24.92"
                    rx="2.2"
                    ry="2.2"
                />
                <rect
                    fill="#cadef9"
                    x="47.15"
                    y="46.34"
                    width="6.02"
                    height="24.92"
                    rx="2.2"
                    ry="2.2"
                />
                <rect
                    fill="#cadef9"
                    x="36.51"
                    y="46.34"
                    width="6.02"
                    height="24.92"
                    rx="2.2"
                    ry="2.2"
                />
                <rect
                    fill="#cadef9"
                    x="57.91"
                    y="46.34"
                    width="6.02"
                    height="24.92"
                    rx="2.2"
                    ry="2.2"
                />
                <rect
                    fill="#cadef9"
                    x="68.68"
                    y="46.34"
                    width="6.02"
                    height="24.92"
                    rx="2.2"
                    ry="2.2"
                />
                <ellipse
                    fill="#ffc03a"
                    cx="35.06"
                    cy="31.91"
                    rx="7.43"
                    ry="7.34"
                />
                <path
                    fill="#5f5271"
                    d="M35.06,25.94a6,6,0,1,1-6.06,6,6,6,0,0,1,6.06-6m0-2.74a8.71,8.71,0,1,0,8.8,8.71,8.76,8.76,0,0,0-8.8-8.71Z"
                />
                <path
                    fill={COLOR_BRAND3}
                    d="M8.91,63.29a3.38,3.38,0,0,1-2.38-1,3.32,3.32,0,0,1-.11-4.65l26-27.92a3.4,3.4,0,0,1,4.86-.11,3.31,3.31,0,0,1,.11,4.65l-26,27.92a3.41,3.41,0,0,1-2.49,1.08Z"
                />
                <path
                    fill="#5f5271"
                    d="M34.9,30a2,2,0,0,1,1.42.58,2,2,0,0,1,.06,2.74l-26,27.92a2,2,0,0,1-2.9.07h0a2,2,0,0,1-.06-2.74l26-27.92A2,2,0,0,1,34.9,30m0-2.74a4.78,4.78,0,0,0-3.49,1.52l-26,27.92a4.68,4.68,0,0,0,.15,6.56,4.77,4.77,0,0,0,6.82-.16l26-27.92a4.68,4.68,0,0,0-.15-6.56,4.74,4.74,0,0,0-3.33-1.36Z"
                />
                <ellipse
                    fill="#ffc03a"
                    cx="65.28"
                    cy="31.91"
                    rx="7.43"
                    ry="7.34"
                />
                <path
                    fill="#5f5271"
                    d="M65.28,25.94a6,6,0,1,1-6.06,6,6,6,0,0,1,6.06-6m0-2.74a8.71,8.71,0,1,0,8.8,8.71,8.76,8.76,0,0,0-8.8-8.71Z"
                />
                <path
                    fill={COLOR_BRAND3}
                    d="M91.43,63.29a3.41,3.41,0,0,1-2.49-1.08L63,34.29a3.31,3.31,0,0,1,.11-4.65,3.4,3.4,0,0,1,4.86.11l26,27.92a3.32,3.32,0,0,1-.11,4.65A3.38,3.38,0,0,1,91.43,63.29Z"
                />
                <path
                    fill="#5f5271"
                    d="M65.44,30a2,2,0,0,1,1.48.64l26,27.92a2,2,0,0,1-.06,2.74h0a2,2,0,0,1-2.9-.07L64,33.36A2,2,0,0,1,64,30.62,2,2,0,0,1,65.44,30m0-2.74h0a4.74,4.74,0,0,0-3.33,1.36A4.68,4.68,0,0,0,62,35.23l26,27.92a4.77,4.77,0,0,0,6.82.16,4.68,4.68,0,0,0,.15-6.56l-26-27.92a4.78,4.78,0,0,0-3.49-1.52Z"
                />
            </svg>
        )
    }
}

// Public Definitions -------------------------------------------------------->

export const icons = new SpinnerIcons()
